import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {NgSelectModule} from '@ng-select/ng-select';
import {TranslateModule} from '@ngx-translate/core';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {SharedModule} from '@shared/shared.module';
import {
  StatusEventPageComponent
} from '@components/pages/page-components/status-event-page/status-event-page/status-event-page.component';
import {
  StatusEventPageCloneComponent
} from '@components/pages/page-components/status-event-page/modals/status-event-page-clone/status-event-page-clone.component';
import {
  StatusEventPageEditConfigurationComponent
} from '@components/pages/page-components/status-event-page/modals/status-event-page-edit-configuration/status-event-page-edit-configuration.component';
import {
  StatusEventPageActionsComponent
} from '@components/pages/page-components/status-event-page/status-event-page-actions/status-event-page-actions.component';


import {
  StatusEventRowComponent
} from '@components/pages/page-components/status-event-page/status-event-row/status-event-row.component';
import {
  StatusEventPageConfigurationSelectedItemComponent
} from '@components/pages/page-components/status-event-page/modals/status-event-page-configuration-selected-item/status-event-page-configuration-selected-item.component';
import {PaginationComponent} from '@shared/pagination/pagination.component';


@NgModule({
  declarations: [
    StatusEventPageComponent,
    StatusEventPageCloneComponent,
    StatusEventPageEditConfigurationComponent,
    StatusEventPageActionsComponent,
    StatusEventRowComponent,
    StatusEventPageConfigurationSelectedItemComponent,
    PaginationComponent,
  ],
  exports: [
    StatusEventPageActionsComponent,
    StatusEventPageComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    NgSelectModule,
    TranslateModule,
    NgbModule,
    FormsModule
  ]
})
export class StatusEventPageModule {
}
